// TODO: vitest component test (pages are covered by Playwright e2e)
import { useNavigate, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader, Breadcrumbs } from '@/components/layout'
import { Card, Skeleton } from '@/components/ui'
import { useCustomer } from '@/hooks/useCustomers'
import { CustomerFields } from '@/components/customers/CustomerFields'
import type { Customer } from '@/types'

export function CustomerFormPage() {
  const { t } = useTranslation('customers')
  const { id } = useParams<{ id: string }>()
  const isEdit = !!id
  const customerId = Number(id)
  const navigate = useNavigate()

  const { data: customer, isLoading } = useCustomer(customerId)

  const handleSave = (saved: Customer) => {
    navigate(`/customers/${saved.id}`)
  }

  if (isEdit && isLoading) {
    return (
        <div className="space-y-6">
          <Skeleton className="h-8 w-64" />
          <Card>
            <Skeleton className="h-96" />
          </Card>
        </div>
    )
  }

  return (
      <div className="space-y-6">
        <Breadcrumbs
          items={[
            { label: t('title'), href: '/customers' },
            ...(isEdit && customer ? [{ label: customer.name, href: `/customers/${customerId}` }] : []),
            { label: isEdit ? t('edit_customer') : t('new_customer') },
          ]}
        />

        <PageHeader
          title={isEdit ? t('edit_customer') : t('new_customer')}
          description={isEdit ? t('edit_description') : t('new_description')}
        />

        <CustomerFields
          customer={isEdit ? (customer ?? null) : null}
          onSave={handleSave}
        />
      </div>
  )
}
